<template>
  <section class="-wrapper-tile feature- -summary-grid -border-radius-1">
    <div class="-wrapper-column -width-100">
      <div class="-header">
        <p class="-h2 -font-weight-medium">{{ $t('pages_contract_ContractDetail.contractinfo') }}</p>

      </div>
      <div class="-wrapper -px-5 -pt-5">

        <g-dropdown
          :id="'contract-detail-month_'+month"
          :value=month
          variant="borderless"
          dropdownType="default"
          buttonSize="large"
          @change="onSelected"
        >
          <g-dropdown-item-wrap>
            <g-dropdown-item :key="val" :text="val" :value="val" v-for="val in dateList" />
          </g-dropdown-item-wrap>

        </g-dropdown>

        <p id="contract-detail-status-ing" v-if="$t('pages_contract_ContractInfo.contract.ing') ===contractDetail.contractStatusName" class="-tag green- -ml-2">
          {{ contractDetail.contractStatusName }}
        </p>
        <p id="contract-detail-status-end" v-if="$t('pages_contract_ContractDetail.contract.end') ===contractDetail.contractStatusName" class="-tag gray- -ml-2">
          {{ contractDetail.contractStatusName }}
        </p>
        <p  id="contract-detail-status-needextend" v-if="$t('pages_contract_ContractDetail.contract.needextend') ===contractDetail.contractStatusName" class="-tag yellow- -ml-2">
          {{ contractDetail.contractStatusName }}
        </p>
        <p  id="contract-detail-status-exceed" v-if="$t('pages_contract_ContractInfo.contract.exceed') ===contractDetail.contractStatusName" class="-tag red- -ml-2">
          {{ contractDetail.contractStatusName }}
        </p>

      </div>
      <div class="-wrapper -px-5">
        <time class="-description" id="contract-detail-status-date">{{ contractDetail.billStartDate }} ~ {{ contractDetail.billEndDate }}</time>
      </div>

      <div class="-wrapper between- -mt-2 -px-5 -pb-3">
        <p class="--wrapper start-">
        </p>
        <p class="-wrapper-column end- -number l- -ml-2" id="contract-detail-status-totalTradeAmountByKrw">
          {{ contractDetail.totalTradeAmountByKrw }}
          <span class="-color-gray-1 -font-size-12">{{$t('pages_contract_ContractDetail.includeVat')}}</span>
        </p>
      </div>


      <div class="-wrapper-column -bg-lightgray-3 -px-5 -pb-5">
        <div class="-wrapper between- -py-2 -border-bottom">
          <p class="-h4 -font-weight-medium">{{ $t('pages_contract_ContractDetail.contractinfo') }}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.contract.date') }}</p>
          <p class="-number xs- -color-gray-1 line-height-20" id="contract-detail-contractDate">
            {{ contractDetail.contractDate }}
          </p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.contract.startDate') }}</p>
          <p class="-number xs- -color-gray-1 line-height-20" id="contract-detail-startDate">{{ contractDetail.startDate }}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.contract.endDate') }}</p>
          <p class="-number xs- -color-gray-1 line-height-20" id="contract-detail-endDate">{{ contractDetail.endDate }}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.contract.invoiceDocumentDate') }}</p>
          <p class="-number xs- -color-gray-1 line-height-20"  id="contract-detail-invoiceMonth">{{ contractDetail.invoiceMonth }}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.contract.paymethodName') }}</p>
          <p class="-number xs- -color-gray-1 line-height-20" id="contract-detail-payCodeName">{{ contractDetail.payCodeName }}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.contract.termsOfPaymentKey') }}</p>
          <p class="-number xs- -color-gray-1 line-height-20">{{ $t('pages_contract_ContractDetail.contract.termsOfPaymentName') }}</p>
        </div>
      </div>

      <div class="-wrapper-column -bg-lightgray-3 -px-5 -pb-5">
        <div class="-wrapper between- -pb-2 -border-bottom">
          <p class="-h4">{{ $t('pages_contract_ContractDetail.salese.salesInfo') }}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.salese.sales.name') }}</p>
          <p class="-number xs- -color-gray-1 line-height-20" id="contract-detail-employeeName">{{ contractDetail.employeeName }}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.salese.sales.telNo') }}</p>
          <p class="-number xs- -color-gray-1 line-height-20" id="contract-detail-employeeTel">{{ contractDetail.employeeTel }}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.salese.sales.email') }}</p>
          <a :href="`mailto:${contractDetail.employeeEmail}`" class="-number xs- -color-blue-1 line-height-20 link-" id="contract-detail-employeeEmail">
            {{ contractDetail.employeeEmail }}</a>
        </div>
      </div>

      <div class="-wrapper-column -bg-lightgray-3 -px-5 -pb-5">
        <div class="-wrapper between- -pb-2 -border-bottom">
          <p class="-h4">{{ $t('pages_contract_ContractDetail.salese.billInfo') }}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center- line-height-20">{{ $t('pages_contract_ContractDetail.salese.sales.email') }}</p>
          <a :href="`mailto:ccc@bespinglobal.com`" class="-number xs- -color-blue-1 line-height-20 link-" id="contract-detail-cccEmail">
            ccc@bespinglobal.com</a>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {AUTH_GROUP} from "@/constants/constants";
export default {
  data () {
    return {
      month : '',
    }
  },
  computed: {
    ...mapGetters('contract', ['contractDetail']),
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('contract', ['dateList'])
  },
  methods: {
    ...mapActions('contract', ['getContractsWithId']),

    onSelected (month) {

      let param = {};
      param.companyCode = this.$route.query.companyCode;
      param.id = this.$route.query.id;
      param.month = month.replace('-','');

      this.getContractsWithId(param)
      this.$emit('on-selected',param)
    }
  },
  beforeMount() {

    let monthGubun = this.$route.query.month;
    this.month =monthGubun.substr(0,4)+"-"+monthGubun.substr(4,2);
    let param = {}
    param.empNo = this.userInfo.empNo
    param.id = this.$route.query.id
    param.month = this.$route.query.month;
    param.companyCode =this.$route.query.companyCode;
    this.getContractsWithId(param)


    if(this.userInfo.auth === AUTH_GROUP.BespinSales){
      if(this.userInfo.empNo !==this.$route.query.empNo){
          this.$showToast(this.$t('pages_contract_ContractDetail.no.auth'))
          this.$popupManager.close(this.instKey)
          this.$router.push("/")
      }
    }else if(this.userInfo.auth === AUTH_GROUP.AccountManager){
      if(  (this.userInfo.customerCode+this.userInfo.customerDeptCode !==this.$route.query.customerCode) ){
        this.$showToast(this.$t('pages_contract_ContractDetail.no.auth'))
        this.$popupManager.close(this.instKey)
        this.$router.push("/")
      }
    }


  }

}

</script>



// WEBPACK FOOTER //
// src/pages/contract/components/ContractDetailContractInfo.vue